module.exports = __webpack_public_path__ + "img/plumber_demo-600x450.b01c4585.jpg";